// ─── Environment-Aware Logger ───────────────────────────────────────────────
// Wraps console methods so debug/info logs are silenced in production while
// errors and warnings remain visible. All tracking and analytics code should
// use this instead of bare console.log().
//
// Usage:
//   import logger from "../utils/logger";
//   logger.debug("some debug info", data);   // silenced in production
//   logger.info("user action", data);          // silenced in production
//   logger.warn("something unexpected", data); // always visible
//   logger.error("failed to save", err);       // always visible
// ────────────────────────────────────────────────────────────────────────────

const isDev = process.env.NODE_ENV === "development";

const noop = () => {};

const logger = {
  /** Debug-level logging — silenced in production */
  debug: isDev ? console.debug.bind(console) : noop,

  /** Info-level logging — silenced in production */
  info: isDev ? console.info.bind(console) : noop,

  /** Warning — always visible */
  warn: console.warn.bind(console),

  /** Error — always visible */
  error: console.error.bind(console),
};

export default logger;
